<div *ngIf="reportType == 'YeneBakiJahiratPratinidiReport'">

    <div class="report-container" id="print-section">

        <div class="report-header">
            <h2>जाहिरात येणे बाकी - {{ offRepName }}</h2>
            <!-- ✅ Point 4: Show from-to date range -->
            <p>
                दिनांक:
                <span *ngIf="startDate && endDate">
                    {{ startDate | date:'dd-MM-yyyy' }} ते {{ endDate | date:'dd-MM-yyyy' }}
                </span>
                <span *ngIf="!startDate || !endDate">
                    {{ currentDate | date:'dd-MM-yyyy' }}
                </span>
            </p>
        </div>

        <!-- Loading -->
        <div *ngIf="isLoading" style="text-align:center; padding: 30px;">
            <mat-spinner diameter="40"></mat-spinner>
            <p>डेटा लोड होत आहे...</p>
        </div>

        <!-- No data -->
        <div *ngIf="!isLoading && onlyOutstandingVB.length === 0" style="text-align:center; padding:30px;">
            <p>कोणताही डेटा सापडला नाही.</p>
        </div>

        <table class="outstanding-table" *ngIf="!isLoading && onlyOutstandingVB.length > 0">
            <colgroup>
                <!-- ✅ Point 1 & 2: Fixed widths so table doesn't spread too much -->
                <col style="min-width: 160px; width: 180px;"> <!-- प्रतिनिधी -->
                <col style="min-width: 100px; width: 120px;"> <!-- ठिकाण -->
                <col *ngFor="let y of earlyYears" style="width: 80px;">
                <col *ngIf="earlyYears.length > 0" style="width: 90px;"> <!-- early total -->
                <col *ngFor="let y of recentYears" style="width: 85px;">
                <col style="width: 90px;"> <!-- grand total -->
            </colgroup>

            <thead>
                <tr>
                    <th rowspan="2">प्रतिनिधी</th>
                    <th rowspan="2">ठिकाण</th>

                    <th [attr.colspan]="earlyYears.length" *ngIf="earlyYears.length > 0">
                        {{ earlyYears[0] }} ते {{ earlyYears[earlyYears.length - 1] }}
                    </th>
                    <th rowspan="2" class="grey-cell" *ngIf="earlyYears.length > 0">
                        एकूण<br>({{ getEarlyYearsLabel() }})
                    </th>
                    <th *ngFor="let year of recentYears">{{ year }}</th>

                    <th rowspan="2" class="grey-cell">एकूण</th>
                </tr>
                <tr>
                    <th *ngFor="let year of earlyYears">{{ year }}</th>
                    <th *ngFor="let year of recentYears; let i = index">{{ i + 1 }}</th>
                </tr>
            </thead>

            <tbody>

                <ng-container *ngFor="let off of onlyOutstandingVB; let oi = index">

                    <!-- Office Header -->
                    <tr class="office-header-row">
                        <td [attr.colspan]="allYears.length + (earlyYears.length > 0 ? 4 : 3)">
                            {{ oi + 1 }}. {{ off.off_rep_name }}
                            <span *ngIf="off.office_rep_mob"> / {{ off.office_rep_mob }}</span>
                        </td>
                    </tr>

                    <!-- Rep Rows -->
                    <!-- ✅ Point 3: Added class "rep-data-row" to control bold separately -->
                    <tr *ngFor="let rep of off.rep_data; let ri = index" class="rep-data-row"  >

                        <td class="rep-name-cell">{{ oi + 1 }}.{{ ri + 1 }} {{ rep.rep_name }}</td>
                        <td>{{ rep.district }}</td>

                        <!-- Early Years -->
                        <td class="text-right" *ngFor="let year of earlyYears"  class="text-right">
                            {{ formatCurrency(rep.pending[year]) }}
                        </td>

                        <!-- Early Total -->
                        <td class="text-right grey-cell" *ngIf="earlyYears.length > 0"  class="text-right">
                            {{ formatCurrency(rep.total_18_21) }}
                        </td>

                        <!-- Recent Years -->
                        <td class="text-right" *ngFor="let year of recentYears"  class="text-right">
                            {{ formatCurrency(rep.pending[year]) }}
                        </td>

                        <!-- Grand Total -->
                        <td class="text-right grey-cell"  class="text-right">
                            {{ formatCurrency(rep.grand_total) }}
                        </td>

                    </tr>

                    <!-- Office Totals -->
                    <tr class="office-total-row" style="text-align: right;">
                        <td colspan="2"><strong>एकूण : {{ off.off_rep_name }}</strong></td>

                        <td class="text-right" *ngFor="let year of earlyYears"  class="text-right">
                            <strong>{{ formatCurrency(getOffRepTotal(off, year)) }}</strong>
                        </td>

                        <td class="text-right grey-cell" *ngIf="earlyYears.length > 0"  class="text-right">
                            <strong>{{ formatCurrency(getOffRepEarlyTotal(off)) }}</strong>
                        </td>

                        <td class="text-right" *ngFor="let year of recentYears"  class="text-right">
                            <strong>{{ formatCurrency(getOffRepTotal(off, year)) }}</strong>
                        </td>

                        <td class="text-right grey-cell"  class="text-right">
                            <strong>{{ formatCurrency(getOffRepGrandTotal(off)) }}</strong>
                        </td>
                    </tr>

                </ng-container>

                <!-- Grand Total -->
                <tr class="grand-total-row">
                    <td colspan="2"><strong>एकूण (सर्व)</strong></td>

                    <td class="text-right" *ngFor="let year of earlyYears"  class="text-right">
                        <strong>{{ formatCurrency(getGrandTotal(year)) }}</strong>
                    </td>

                    <td class="text-right grey-cell" *ngIf="earlyYears.length > 0"  class="text-right">
                        <strong>{{ formatCurrency(getGrandEarlyTotal()) }}</strong>
                    </td>

                    <td class="text-right" *ngFor="let year of recentYears"  class="text-right">
                        <strong>{{ formatCurrency(getGrandTotal(year)) }}</strong>
                    </td>

                    <td class="text-right grey-cell"  class="text-right">
                        <strong>{{ formatCurrency(getGrandOverallTotal()) }}</strong>
                    </td>
                </tr>

            </tbody>
        </table>

    </div>

    <div class="actions noPrint">
        <button mat-raised-button color="primary" (click)="exportExcel('Outstanding_Report')">Export Excel</button>
        <button mat-raised-button color="accent" printSectionId="print-section" (click)="printPageA4Landscape()">Print
            Report</button>
        <button class="btn btn-close noPrint" mat-button mat-dialog-close>
            <mat-icon>close</mat-icon> Close
        </button>
    </div>

</div>